var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "main-section main-location"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg tit--point line-height-1 white--text"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.lang === "ko" ? "찾아오시는 길" : "Location") + " ")]), _c('span', {
    staticClass: "ko tit--point__circle",
    attrs: {
      "data-aos": "zoom-in"
    }
  })])]), _c('v-row', [_c('v-col', {
    staticClass: "mb-10px mb-lg-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "8"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": `/images/main/location/map-${_vm.lang}.png`,
      "max-width": "876",
      "contain": ""
    }
  })], 1), _c('v-col', {
    staticClass: "border-md-l border-white",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "h-100 d-flex align-center"
  }, [_c('div', {
    staticClass: "pl-xl-100px"
  }, [_vm._l(_vm.currentItems, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-12px mb-lg-60px",
      attrs: {
        "data-aos": "fade-up",
        "data-aos-delay": 100 * index
      }
    }, [_c('p', {
      staticClass: "txt txt--sm font-weight-meidum line-height-1 white--text mb-4px mb-lg-10px"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c(item.name === 'Tel' || item.name === 'E-mail' ? 'a' : 'p', {
      tag: "component",
      staticClass: "txt grey--text text--lighten-3",
      class: {
        'v-btn--text-underline': item.name === 'Tel' || item.name === 'E-mail'
      },
      attrs: {
        "href": item.name === 'Tel' ? `tel:${item.text}` : item.name === 'E-mail' ? `mailto:${item.text}` : null
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")])], 1);
  }), _c('v-row', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, _vm._l(_vm.currentLinks, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "auto"
      }
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "d-sr-only"
    }, [_vm._v(_vm._s(item.name))]), _c('i', {
      staticClass: "icon",
      class: item.name == 'Kakao Map' ? 'icon-kakaomap' : item.name == 'Naver Map' ? 'icon-navermap' : item.name == 'TMAP' ? 'icon-tmap' : item.name == 'Google Maps' ? 'icon-googlemap' : null
    })])]);
  }), 1)], 2)])])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }